import { axiosGet, axiosPost } from "../../../react_axios/Axios"
import { SELECT_APPLICATION_ACTION_TYPE, headers, GET_SPONSORSHIP_LIST, getSponsershipListUrl, GET_SPONSORSHIP_DETAILS, INSERT_SPONSORSHIP_INTEREST, getSponsershipDetailsUrl, insertSponsorshipInterestUrl } from "../../../utils/constants"



export const getSponsershipList_action = (ExhCompanyName, VisitorCompanyName, SponsorshipTypeId) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhCompanyName: ExhCompanyName != '' ? ExhCompanyName : null,
            VisitorCompanyName: VisitorCompanyName != '' ? VisitorCompanyName : null,
            SponsorshipTypeId: SponsorshipTypeId != '' ? SponsorshipTypeId : null,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            // AccountID: sessionStorage.getItem('AccountIDSS').,/
        }
        console.log("SelectApplication Action------->", params)

        const res = await axiosGet(getSponsershipListUrl, params, headers)
        console.log("SelectApplication Action------->", res)

        dispatch({
            type: GET_SPONSORSHIP_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getSponsershipDetails_action = () => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationId: sessionStorage.getItem('ExhRegistrationIDSS'),
            ExhVisitorId: sessionStorage.getItem('currentVisitorID') != '' && sessionStorage.getItem('currentVisitorID') != null ? (sessionStorage.getItem('currentVisitorID')) : '',
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            // AccountID: sessionStorage.getItem('AccountIDSS').,/
        }
        console.log("SelectApplication Action------->", params)

        const res = await axiosGet(getSponsershipDetailsUrl, params, headers)
        console.log("SelectApplication Action------->", res)

        dispatch({
            type: GET_SPONSORSHIP_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertSponsorshipInterest_action = (SponsorshipHdrID, AppliedQty, AdditionalNote, maildata) => async (dispatch) => {
    maildata.UserId = JSON.parse(sessionStorage.getItem('loginDataSS')).UserID
    maildata.ExhibitionID = sessionStorage.getItem('sessionExhibitionID')
    maildata.ExhRegistrationID = sessionStorage.getItem('ExhRegistrationIDSS')
    maildata.ExhVisitorID = (sessionStorage.getItem('currentVisitorID'))
    try {
        const mapData = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationId: sessionStorage.getItem('ExhRegistrationIDSS'),
            ExhVisitorId: sessionStorage.getItem('currentVisitorID') != '' && sessionStorage.getItem('currentVisitorID') != null ? (sessionStorage.getItem('currentVisitorID')) : '',
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            SponsorshipHdrID: SponsorshipHdrID,
            AppliedQty: AppliedQty,
            AdditionalNote: AdditionalNote,
            maildata: maildata
        }
        console.log("Space Booking Action ----->", mapData)
        const res = await axiosPost(insertSponsorshipInterestUrl, mapData, headers)

        dispatch({
            type: INSERT_SPONSORSHIP_INTEREST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }

}